// src/hooks/transportations/useRestoreAllTransportations.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreAllTransportations } from "../../api/apiTransportations";
import parseError from "../../utils/parseError";

const useRestoreAllTransportations = () => {
    const queryClient = useQueryClient();

    const {
        mutate: restoreAllTransportationsMutate,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: restoreAllTransportations,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["transportations"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to restore transportations");
        },
    });

    return {
        restoreAllTransportations: restoreAllTransportationsMutate,
        isRestoreAll: isPending || isLoading,
    };
};

export default useRestoreAllTransportations;
